$(function () {
    'use strict';
    var $fn = {},
        $el = {
            window       : $(window),
            html         : $('html'),
            body         : $('body'),
            document     : $('.l-document'),
        },
        param = {
            winW        : window.innerWidth || $el.window.width(),
            winH        : window.innerHeight || $el.window.height(),
            docW        : $el.document.outerWidth(),
            docH        : $el.document.outerHeight(),
            path:'',
            center_coordinates:'',
            text:'',
            text2:'',
            category:'',
            switch_flg:''

        };


    // $fn.mainimgSize = function () {
    //     var $target = $('.main-carousel');
    //     var $target_parent = $('.carousel-cell img');
    //
    //     var WinW = $(window).width();
    //     if(WinW <= 768){
    //         var ratio = 1.561;
    //
    //     }else{
    //         var ratio = 0.539;
    //
    //     }
    //     var mainImgW =$target_parent.width();
    //     var mainH = mainImgW*ratio;
    //     $target.css({
    //         height:mainH+'px'
    //     })
    // };
    //
    //
    // $el.window.resize('load', function () {
    //     $fn.mainimgSize();
    // });
    //
    //
    // $fn.headerToggle = function () {
    //     var $target = $('.toggle');
    //
    //     $target.on('click',function(){
    //         $('body').toggleClass('open');
    //         if( $('body').hasClass('open')){
    //         }else{
    //         }
    //     });
    // };
    // $fn.headerToggle();
    //
    // $('.sp_nav li').on('click',function () {
    //
    //     $('body').toggleClass('open');
    //     if( $('body').hasClass('open')){
    //     }else{
    //     }
    // });
    //
    // $('.sp_nav p').on('click',function () {
    //
    //     $('body').toggleClass('open');
    //     if( $('body').hasClass('open')){
    //     }else{
    //     }
    // });
    //
    // $('.l-section--steward li').on('click',function () {
    //     var modal = $('#modal');
    //     var body = $('body');
    //     body.addClass('open-modal');
    //     var index = $(this).index();
    //     $('.modal--inner li').each(function(){
    //         $(this).css({
    //             display:'none'
    //         });
    //     });
    //     $('.modal--inner li:eq('+ index +')').css({
    //         display:'block'
    //     });
    // });
    //
    // $('#modal .close').on('click',function () {
    //     var $body = $('body');
    //     $body.removeClass('open-modal');
    // });
    //
    // $('.sp-navi li').on('click',function () {
    //     var $body = $('body');
    //     $body.removeClass('open');
    // });
    //
    //
    // var controller = new ScrollMagic.Controller();
    // var tl = new TimelineMax();
    // var tl2 = new TimelineMax();
    // var tl3 = new TimelineMax();
    // var tl4 = new TimelineMax();
    // var tl5 = new TimelineMax();
    // var tl6 = new TimelineMax();
    // var tl7 = new TimelineMax();
    // var tl8 = new TimelineMax();
    // var child = $(this).find(".bg-logo");
    //
    // tl2.staggerFrom(".regionalism--box", 1.25, {
    //     y: 100,
    //     opacity:0,
    //     ease: Expo.easeOut,
    //     stagger: {
    //         from: "center",
    //         amount: 0.25
    //     }
    // });
    //
    // tl3.staggerFrom(".regionality--box", 1.25, {
    //     y: 100,
    //     opacity:0,
    //     ease: Expo.easeOut,
    //     stagger: {
    //         from: "center",
    //         amount: 0.25
    //     }
    // });
    //
    // tl4.staggerFrom(".l-section--catch--inner", 1.25, {
    //     y: 100,
    //     opacity:0,
    //     ease: Expo.easeOut,
    //     stagger: {
    //         from: "center",
    //         amount: 0.25
    //     }
    // });
    //
    // tl5.staggerFrom(".l-section--steward li", 1.25, {
    //     y: 100,
    //     opacity:0,
    //     ease: Expo.easeOut,
    //     stagger: {
    //         from: "left",
    //         amount: 0.5
    //     }
    // });
    //
    // tl6.staggerFrom(".master-box", 1.25, {
    //     y: 100,
    //     opacity:0,
    //     ease: Expo.easeOut,
    //     stagger: {
    //         from: "left",
    //         amount: 0.5
    //     }
    // });
    // tl7.staggerFrom(".l-footer--inner", 1.25, {
    //     y: 100,
    //     opacity:0,
    //     ease: Expo.easeOut,
    //     stagger: {
    //         from: "left",
    //         amount: 0.5
    //     }
    // });
    //
    // tl8.staggerFrom(".info--inner", 1.25, {
    //     y: 100,
    //     opacity:0,
    //     ease: Expo.easeOut,
    //     stagger: {
    //         from: "left",
    //         amount: 0.5
    //     }
    // });
    //
    //
    //
    // var scene2 = new ScrollMagic.Scene({
    //     triggerElement: ".l-section--regionalism",
    // })
    //
    //     .setTween(tl2)
    //     .addTo(controller);
    // var scene3 = new ScrollMagic.Scene({
    //     triggerElement: ".regionality--box",
    // })
    //
    //     .setTween(tl3)
    //     .addTo(controller);
    // var scene4 = new ScrollMagic.Scene({
    //     triggerElement: ".l-section--catch",
    // })
    //
    //     .setTween(tl4)
    //     .addTo(controller);
    //
    // var scene5 = new ScrollMagic.Scene({
    //     triggerElement: ".l-section--steward",
    // })
    //
    //     .setTween(tl5)
    //     .addTo(controller);
    //
    // var scene6 = new ScrollMagic.Scene({
    //     triggerElement: "#master-box",
    // })
    //
    //     .setTween(tl6)
    //     .addTo(controller);
    //
    // var scene7 = new ScrollMagic.Scene({
    //     triggerElement: ".l-footer",
    // })
    //
    //     .setTween(tl7)
    //     .addTo(controller);
    //
    // var scene8 = new ScrollMagic.Scene({
    //     triggerElement: ".info",
    // })
    //
    //     .setTween(tl8)
    //     .addTo(controller);
    //
    //
    //
    // tl.to(child, 1, { y: -280, ease: Linear.easeNone });
    // var scene = new ScrollMagic.Scene({
    //     triggerElement: '.l-section--catch',
    //     triggerHook: 1,
    //     duration: "160%"
    // })
    //     .setTween(tl)
    //     .addTo(controller);

    /* ************************************************
      * smoothScroll
      *
      * スムーススクロール
      *
     ************************************************* */
    $fn.smoothScroll = function () {
        var headerHight = 80; //ヘッダの高さ
        $('body').on('click', 'a[href^="#"]', function () {
            var href= $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            var position = target.offset().top-headerHight;
            $('body,html').animate({scrollTop:position}, 800, 'easeInOutExpo');
            return false;
        });
    };
    $fn.smoothScroll();

    $fn.googlemaps = function () {
        if ($('#map').length) {
            var coordinates = {
                lat: 35.673148,
                lng: 139.740694
            };
            if (param.winW <= 768) {
                param.center_coordinates = {
                    lat: 35.673148,
                    lng: 139.740694
                };
            }else{
                param.center_coordinates = {
                    lat: 35.673148,
                    lng: 139.740694
                };
            }

            var zoom;

            if (param.winW <= 750) {
                zoom = 15;
            } else {
                zoom = 15;
            }

            var maps = new GMaps({
                div: '#map',
                zoom: zoom,
                lat: param.center_coordinates.lat,
                lng: param.center_coordinates.lng,
                scrollwheel: false,
                zoomControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                overviewMapControl: false,
                resize: function () {
                    this.setCenter(param.center_coordinates);
                }

            });

            maps.addMarker({
                lat: coordinates.lat,
                lng: coordinates.lng,
            });



            var styles = [
                {
                    "featureType": "all",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -120
                        },
                        {
                            "gamma": 1.0
                        }
                    ]
                }
            ];
            maps.addStyle({
                styledMapName: "Styled Map",
                styles: styles,
                mapTypeId: "map_style"
            });

            maps.setStyle("map_style");
        }
        ;
    }
    $fn.googlemaps();

});

$(window).on('load',function(){
    var $fn = {},
        $el = {
            window       : $(window),
            html         : $('html'),
            body         : $('body'),
            document     : $('.l-document'),
            recruitSlide : ''
        },
        param = {
        };
   });